<template>
    <div class="pay-body">
        <backindex :msg="payMsg"></backindex>
        <!--顶部信息-->
        <div class="pay-title">
            <p class="pay-user">{{$t("account")}}：{{user.username}}</p>
            <p class="pay-coin">{{$t("balance")}}：<span>{{user.score}}</span>{{$t("coin")}}</p>
        </div>
        <!--储值方式-->
        <div class="pay-style">
            <p>{{$t("payType")}}：</p>
            <div class="style-area-old">
                <select name="pays_type" v-model="pay_pm_id">
                    <option value="gash_tw">Gash Point</option>
                    <option value="chthinet_tw">中華電信HiNet</option>
                    <option value="cht839_tw">839小額付款</option>
                    <option value="tm_tw">台灣大哥大</option>
                    <option value="aptg_tw">亞太電信</option>
                    <option value="chtland_tw">中華電信市內電話輕松付</option>
                    <option value="fetnet_tw" selected>遠傳</option>
                </select>
            </div>
        </div>
        <!--储值金额-->
        <div class="pay-style">
            <p>{{$t("payAmount")}}：</p>
            <div class="style-area-old">
                <select name="paynum" v-model="paynum">
                    <option value="50" >50</option>
                    <option value="150" >150</option>
                    <option value="500" >500</option>
                    <option value="1000" >1000</option>
                    <option value="2000" >2000</option>
                    <option value="3000" >3000</option>
                    <option value="5000" >5000</option>
                </select>
            </div>
        </div>
        <!--获得书币-->
        <p class="get-coin">{{$t("resultCoin")}}：{{getSaveCoin}}{{$t("coin")}}<span>{{$t("giftCoin")}}{{getAddCoin}}{{$t("coin")}}</span></p>
        <div class="pay-btn-old">
            <div class="pay-click" @click="pftpay">{{$t("pftpay")}}</div>
        </div>
        <div class="pay-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
import backindex from "@/components/common/backindex";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "little",
  components: {
    backindex,
    pagebottom
  },
  mounted: function() {
    this.getUser();
    this.payMsg = this.$t("charge");
  },
  data() {
    return {
      user: {},
      bookId: this.$route.query.id,
      payMsg: "在线储值",
      paynum: 150, //充值金额
      pay_pm_id: "fetnet_tw", //充值方式
      payArr: [
        { payCoin: 50, saveCoin: 1000, addCoin: 0 },
        { payCoin: 150, saveCoin: 3000, addCoin: 150 },
        { payCoin: 500, saveCoin: 10000, addCoin: 1000 },
        { payCoin: 1000, saveCoin: 20000, addCoin: 3000 },
        { payCoin: 2000, saveCoin: 40000, addCoin: 10000 },
        { payCoin: 3000, saveCoin: 60000, addCoin: 18000 },
        { payCoin: 5000, saveCoin: 100000, addCoin: 50000 }
      ]
    };
  },
  computed: {
    //获取saveCoin
    getSaveCoin: function() {
      let saveCoin = null;
      this.payArr.map((item, index) => {
        if (item.payCoin == this.paynum) {
          saveCoin = item.saveCoin;
        }
      });
      return saveCoin;
    },
    //获取addCoin
    getAddCoin: function() {
      let addCoin = null;
      this.payArr.map((item, index) => {
        if (item.payCoin == this.paynum) {
          addCoin = item.addCoin;
        }
      });
      return addCoin;
    }
  },
  methods: {
    getUser: function() {
      this.req.getUser().then(res => {
        if (res.data.id > 0) {
          this.user = res.data;
        }
      });
    },
    //派付通
    pftpay(obj) {
      this.req
        .recharge(5, this.pay_pm_id, this.paynum, this.book_id)
        .then(res => {
          if (res) {
            window.location.href = res.url;
          }
        });
    }
  }
};
</script>

<style scoped>
.pay-body {
  width: 100%;
  height: auto;
}
.pay-bottom {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
}
.pay-title {
  width: 100%;
  height: 1.12rem;
  border-bottom: 0.02rem solid #e6e6e6;
  box-sizing: border-box;
  padding: 0 0.4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
}
.pay-user,
.pay-coin {
  font-size: 0.28rem;
  line-height: 0.28rem;
  color: #4d4d4d;
}
.pay-coin span {
  color: #ff1f4f;
}
.pay-style {
  width: 100%;
  padding: 0 0 0.3rem 0.4rem;
  box-sizing: border-box;
  font-size: 0.3rem;
  line-height: 0.3rem;
  color: #666666;
  font-weight: 700;
  display: flex;
  margin-top: 1em;
  align-items: center;
}
/*存储方式*/
.style-area-old {
  width: auto;
  box-sizing: border-box;
  border: 0.01rem solid #808080;
  border-radius: 0.08rem;
  display: flex;
  position: relative;
}
/*获得金币*/
.get-coin {
  width: 100%;
  padding: 0 0.4rem;
  box-sizing: border-box;
  margin-bottom: 4em;
  margin-top: 1em;
  font-size: 0.3rem;
  line-height: 0.3rem;
  color: #666666;
  font-weight: 700;
}
.get-coin span {
  color: #ff1f4f;
}
.pay-btn-old {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.2rem;
}
.pay-click {
  width: 100%;
  height: 0.84rem;
  font-size: 0.32rem;
  color: #ffffff;
  line-height: 0.84rem;
  background: #ff1f4f;
  border-radius: 0.08rem;
  text-align: center;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/pay/little.vue